const ACTIVE_OPERATIONS_CACHE_TTL_MS = 5000;

const normalizeOperationType = (type) => {
  if (!type) return type;
  switch (type) {
    case 'uploading':
    case 'file_uploading':
      return 'file_upload';
    case 'processing':
    case 'document_processing':
      return 'file_processing';
    case 'deleting':
    case 'file_delete':
      return 'file_deleting';
    case 'report':
    case 'report_generation':
      return 'report_generating';
    default:
      return type;
  }
};

const filterOperationsByReports = (operations, reports) => {
  // Trust the backend as the source of truth for active operations.
  // Previously we filtered based on frontend report status, but this caused operations
  // to disappear when the report completed even though the backend operation was still
  // in "batch_processing" state. The backend is authoritative (syncs with Step Functions),
  // so if it says an operation is active, we should show it.
  if (!Array.isArray(operations)) return [];
  return operations;
};

export {
  ACTIVE_OPERATIONS_CACHE_TTL_MS,
  normalizeOperationType,
  filterOperationsByReports
};
